<ion-col size="12" slot="fixed">
    <div class="calendly-box">
        <!-- Calendly inline widget begin -->
        <!-- <div #container class="calendly-inline-widget" data-auto-load="false"></div> -->
        <!-- Calendly inline widget end -->
    </div>
</ion-col>